// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--1RXzq","inner":"styles-module--inner--2xk3i","boxContainer":"styles-module--box-container--mh6Pe","box":"styles-module--box--2oWZ0"};